<script lang="ts">
	import { m } from '$lib/paraglide/messages';

	import FilterButton from './FilterButton.svelte';
	import { CategoriesSortOptions } from './store.svelte';

	let { currentSort = $bindable() }: { currentSort: CategoriesSortOptions } = $props();

	let isDropdownOpen = $state(false);

	const handleSelect = (value: CategoriesSortOptions) => {
		currentSort = value;
		isDropdownOpen = false;
	};

	const sortIconMap: Record<CategoriesSortOptions, string> = {
		[CategoriesSortOptions.Relevance]: 'icon-[mdi--sort]',
		[CategoriesSortOptions.PriceAsc]: 'icon-[mdi--sort-ascending]',
		[CategoriesSortOptions.PriceDesc]: 'icon-[mdi--sort-descending]',
		[CategoriesSortOptions.Discount]: 'icon-[mdi--percent-outline]',
	};

	export function getSortLabel(option: CategoriesSortOptions): string {
		switch (option) {
			case CategoriesSortOptions.Relevance:
				return m['sort.relevance']();
			case CategoriesSortOptions.PriceAsc:
				return m['sort.price_asc']();
			case CategoriesSortOptions.PriceDesc:
				return m['sort.price_desc']();
			case CategoriesSortOptions.Discount:
				return m['discount']();
			default:
				return '';
		}
	}
</script>

<div class="relative">
	<FilterButton onclick={() => (isDropdownOpen = !isDropdownOpen)} class="xl:min-w-64">
		<div class="flex items-center gap-2">
			<span class={`h-5 w-5 ${sortIconMap[currentSort]}`}></span>
			<span class="font-medium">{getSortLabel(currentSort)}</span>
		</div>
	</FilterButton>

	{#if isDropdownOpen}
		<!-- svelte-ignore a11y_no_static_element_interactions -->
		<!-- svelte-ignore a11y_click_events_have_key_events -->
		<div class="fixed inset-0 z-10" onclick={() => (isDropdownOpen = false)}></div>
	{/if}

	<div
		class={`absolute top-full left-0 z-20 mt-1 w-full overflow-hidden rounded-lg border border-neutral-200 bg-white shadow-lg transition-all duration-200 ${
			isDropdownOpen
				? 'translate-y-0 scale-100 opacity-100'
				: 'pointer-events-none -translate-y-2 scale-95 opacity-0'
		}`}
	>
		{#each Object.values(CategoriesSortOptions) as option (option)}
			<button
				class={`group flex w-full items-center gap-1 px-4 py-3 text-left text-xs transition-colors duration-150 hover:bg-neutral-50 focus:bg-neutral-50 focus:outline-none ${
					currentSort === option
						? 'border-r-2 border-neutral-500 bg-neutral-50 text-neutral-700'
						: 'text-neutral-700'
				}`}
				onclick={() => handleSelect(option)}
			>
				<span
					class={`h-4 w-4 transition-colors ${sortIconMap[option]} ${
						currentSort === option ? 'text-neutral-600' : 'text-neutral-500'
					}`}
				></span>
				<span class="font-medium">{getSortLabel(option)}</span>
				{#if currentSort === option}
					<span class="icon-[mdi--check] ml-auto h-4 w-4 text-neutral-600"></span>
				{/if}
			</button>
		{/each}
	</div>
</div>
